import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

const CustomTheme = definePreset(Aura, {
  primitive: {
    orange: {
      50: '#FFF7E5',
      100: '#FFF0D1',
      200: '#FFE09E',
      300: '#FFD270',
      400: '#FFC342',
      500: '#FFB514',
      600: '#E09900',
      700: '#B27900',
      800: '#755000',
      900: '#3D2A00',
      950: '#1F1500',
    },
    green: {
      50: '#DEF3F4',
      100: '#DEF3F4',
      200: '#DEF3F4',
      300: '#DEF3F4',
      400: '#DEF3F4',
      500: '#64EDA6',
      600: '#007D83',
      700: '#007D83',
      800: '#045559',
      900: '#045559',
      950: '#045559',
    },
    red: {
      50: '#FCF0EE',
      100: '#FFE4E8',
      200: '#F2C3BA',
      300: '#C33D24',
      400: '#E68A7A',
      500: '#440002',
      600: '#DA4D35',
      700: '#C33D24',
      750: '#B84B58',
      800: '#812818',
      900: '#41140C',
      950: '#220B06',
    },
    'dark-blue': {
      50: '#D5D9FC',
      100: '#AAB3F8',
      200: '#5567F1',
      300: '#1229D9',
      400: '#0B1984',
      500: '#040931',
      600: '#030726',
      700: '#02051C',
      800: '#020413',
      900: '#010209',
      950: '#000105',
    },
    blue: {
      50: '#E5F0FB',
      100: '#CAE2F7',
      200: '#9AC7EF',
      300: '#65AAE7',
      400: '#308DDE',
      500: '#1D70B7',
      600: '#175891',
      700: '#11436E',
      800: '#0C2D4B',
      900: '#061523',
      950: '#030B12',
    },
    greyscale: {
      0: '#ffffff',
      25: '#F7F7F7',
      50: '#ECEDEE',
      100: '#DBE2EB',
      200: '#B6C5D8',
      300: '#808793',
      400: '#6E8AB0',
      500: '#516F95',
      600: '#415877',
      700: '#304259',
      800: '#202E43',
      900: '#10161E',
      950: '#090C11',
    },
    brown: {
      500: '#440002',
      600: '#5e1a1a',
      900: '#E2BFBA',
    },
    yellow: {
      300: '#FBFFC8',
    },
  },
  semantic: {
    primary: {
      50: '{brown.500}',
      100: '{brown.500}',
      200: '{brown.500}',
      300: '{brown.500}',
      400: '{brown.500}',
      500: '{brown.500}',
      600: '{brown.600}',
      700: '{brown.900}',
      800: '{brown.900}',
      900: '{brown.900}',
    },
    secondary: {
      50: '{greyscale.50}',
      100: '{greyscale.100}',
      200: '{greyscale.200}',
      300: '{greyscale.300}',
      400: '{greyscale.400}',
      500: '{greyscale.500}',
      600: '{greyscale.600}',
      700: '{greyscale.700}',
      800: '{greyscale.800}',
      900: '{greyscale.900}',
      950: '{greyscale.950}',
    },
    tertiary: {
      50: '#DFE1FB',
      100: '#C2C6F8',
      200: '#858DF0',
      300: '#3C51E4',
      400: '#1A2A8C',
      500: '#040931',
      600: '#03072A',
      700: '#020421',
      800: '#020421',
      900: '#010215',
      950: '#000000',
    },
    quaternary: {
      50: '#F8FAFC',
      100: '#EEF2F7',
      200: '#E0E7F0',
      300: '#CFDAE8',
      400: '#C1D0E1',
      500: '#B1C3D9',
      600: '#7D9BC0',
      700: '#4D719E',
      800: '#344C6A',
      900: '#192533',
      950: '#0D141B',
    },
    danger: {
      50: '{red.50}',
      100: '{red.100}',
      200: '{red.200}',
      300: '{red.300}',
      400: '{red.400}',
      500: '{red.300}',
      600: '{red.600}',
      700: '{red.700}',
      800: '{red.800}',
      900: '{red.900}',
      950: '{red.950}',
    },
    success: {
      50: '{green.50}',
      100: '{green.100}',
      200: '{green.200}',
      300: '{green.300}',
      400: '{green.400}',
      500: '{green.500}',
      600: '{green.600}',
      700: '{green.700}',
      800: '{green.800}',
      900: '{green.900}',
      950: '{green.950}',
    },
  },
  variables: {
    primaryColor: '#007bff',
    passwordMeterBg: '#d9d9d9',
    passwordWeakBg: '#e53935',
    passwordMediumBg: '#ffb300',
    passwordStrongBg: '#43a047',
  },
});

export default CustomTheme;
